import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const leadAssignApi = createApi({
  reducerPath: "leadAssignApi",

  baseQuery: createBaseQueryWithReauth(
    `${import.meta.env.VITE_BASE_API_URL}Lead/`
  ),

  endpoints: (builder) => ({
    // getAllLeads: builder.query({
    //   query: () => ({
    //     url: "GetLeads",
    //     method: "GET",
    //   }),
    // }),

    assignLead: builder.mutation({
      query: (body) => {
        return {
          url: "AssignLead",
          method: "POST",
          body,
        };
      },
    }),

    getAllLeadAssignmentByLeadId: builder.query({
      query: (id) => ({
        url: `GetLeadAssignmentsByLeadId?leadId=${id}`,
        method: "GET",
      }),
    }),

    leadTransfer: builder.mutation({
      query: (body) => {
        return {
          url: "TransferLead",
          method: "POST",
          body,
        };
      },
    }),

    updateLead: builder.mutation({
      query: (body) => {
        return {
          url: "UpdateLead",
          method: "PUT",
          body,
        };
      },
    }),
    // deleteLead: builder.mutation({
    //   query: (id) => ({
    //     url: `DeleteLead?id=${id}`,
    //     method: "DELETE",
    //   }),
    // }),
  }),
});

export const {
  useAssignLeadMutation,
  useGetAllLeadAssignmentByLeadIdQuery,
  useUpdateLeadMutation,
  useLeadTransferMutation,
} = leadAssignApi;

export default leadAssignApi.reducer;
